import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import FirmographicsForm from "@app/analytics/components/FirmographicsForm";
import usePopups from "@app/analytics/hooks/usePopups";
import useAuth from "@app/common/auth/useAuth";
import useUserMetadata from "@app/common/auth/useUserMetadata";
import usePreloadImages from "@app/common/hooks/usePreloadImages";

import Firmographics from "./assets/Firmographics.png";
import {
  FeaturePopupContentTitle,
  FeaturePopupHeroContainer,
  FeaturePopupCloseButton,
  FeaturePopupContent,
  FeaturePopupCard,
} from "./styles";

const FirmographicsPopup = ({
  priority,
  onDismissed,
  firstName,
}: {
  priority: number;
  onDismissed: () => void;
  firstName: string;
}) => {
  usePreloadImages([Firmographics]);

  const { show, reset } = usePopups({
    id: "firmographicsPopup",
    priority,
    shouldShow: true,
  });

  const handleDismiss = () => {
    reset();
    onDismissed();
  };

  if (!show) return null;

  return (
    <Modal
      open
      onClose={handleDismiss}
      disableAutoFocus
      sx={{
        "& .MuiCard-root": {
          minHeight: { sm: "450px" }, // account for when all errors are visible
        },
      }}
    >
      <FeaturePopupCard layout="horizontal" sx={{ height: "auto" }}>
        <FeaturePopupContent width={{ xxs: "100%", md: "50%" }} spacing={2}>
          <FeaturePopupContentTitle>
            {firstName}, customize your Read account based on your role
          </FeaturePopupContentTitle>
          <FirmographicsForm
            onCloseForm={handleDismiss}
            cancelText="Maybe later"
            saveText="Save & continue"
          />
        </FeaturePopupContent>
        <FeaturePopupHeroContainer
          layout="horizontal"
          sx={{
            backgroundColor: "shades.primary.200",
            display: { xxs: "none", sm: "flex" },
          }}
        >
          <Box
            component="img"
            src={Firmographics}
            maxWidth="100%"
            alignSelf="center"
            borderRadius="0 4px 4px 0px"
          />
          <FeaturePopupCloseButton onClick={handleDismiss} />
        </FeaturePopupHeroContainer>
      </FeaturePopupCard>
    </Modal>
  );
};

const FirmographicsPopupGate = (props: { priority: number }) => {
  const { user } = useAuth();
  const { userMetadata, updateUserMetadata } = useUserMetadata();

  const dismissed = userMetadata?.firmographicsRequested;

  const handleDismiss = () => {
    updateUserMetadata.mutate({ firmographicsRequested: true });
  };

  if (dismissed || !user) return null;

  return (
    <FirmographicsPopup
      onDismissed={handleDismiss}
      firstName={user.firstName}
      {...props}
    />
  );
};

export default FirmographicsPopupGate;
